import React from 'react'
import { Grid } from '@mui/material'

import { StyledButton, useStepper } from 'shared'

const ConfirmationStep = ({ closeModal }: { closeModal: () => void }) => {
  const { goToNextStep } = useStepper()

  return (
    <Grid container flexDirection="column" gap="16px">
      <StyledButton
        fullWidth
        color="mint"
        variant="contained"
        onClick={closeModal}
      >
        No, I still want access to Free Products
      </StyledButton>
      <StyledButton
        fullWidth
        color="light"
        variant="contained"
        onClick={goToNextStep}
      >
        Yes i am sure
      </StyledButton>
    </Grid>
  )
}

export default ConfirmationStep
